import { Observable, of } from "rxjs";
import { RejectedPayment } from "app/modules/policy-lists/models/rejected-payment.model";
import { Output, EventEmitter } from "@angular/core";
import { IssueSubmissionResponse, PolicyChangeQuoteResponse } from '../../models';

export class PolicyChangeServiceStub {
    @Output() isOpen: EventEmitter<RejectedPayment>;

    constructor() {
        this.isOpen = new EventEmitter();
    }

    setCarChange(): Observable<any> {
        return of();
    }

    createPolicyChange(): Observable<any> {
        return of();
    }

    policyChangeQuote(): Observable<PolicyChangeQuoteResponse> {
        return of(new PolicyChangeQuoteResponse());
    }
    
    issueSubmission(): Observable<IssueSubmissionResponse> {
        return of(new IssueSubmissionResponse());
    }
}
